export default __webpack_public_path__ + "static/media/cutting_metal.d6da5a6e.png";